module.exports = __webpack_public_path__ + "static/media/swap.9a248e4f.svg";